/* LÉER — Pastilles de couleur sur les cartes produits
   - Détecte l'option couleur (Couleur, Color, Finition, Métal…)
   - Affiche des pastilles métalliques (or, argent, or rose…) EN HAUT À GAUCHE de la photo
   - Un clic sur une pastille change la photo, le lien et le prix SANS ouvrir la fiche produit
   - Barre les couleurs épuisées
*/
(function () {
  'use strict';

  var cfg = window.LeerSwatchConfig || {};
  var lang = (document.documentElement.getAttribute('lang') || 'fr').slice(0, 2).toLowerCase();
  var T = lang === 'en'
    ? { color: 'Colour', soldout: 'Sold out in this colour', more: 'more' }
    : { color: 'Couleur', soldout: 'Épuisé dans cette couleur', more: 'de plus' };
  var MAX_DOTS = 5;
  var COLOR_OPTION = /^(couleurs?|colou?rs?|coloris|finitions?|finish|m[ée]tal|metal|metals?|teintes?|plaqu[ée]|plating)$/i;

  var PALETTE = [
    [/(or\s*rose|ros[ée]\s*gold|rose\s*gold|ros[ée])/i, 'linear-gradient(135deg,#f6dccf 0%,#d9a28c 42%,#b97a65 58%,#f1c9b7 100%)'],
    [/(^|[\s\-\/])(or|gold|dor[ée]e?s?|golden|jaune)([\s\-\/]|$)/i, 'linear-gradient(135deg,#f8e7b0 0%,#d9ac52 42%,#b98a33 58%,#f4dc92 100%)'],
    [/(argent|silver|rhodi|acier|steel|platin)/i, 'linear-gradient(135deg,#fafafa 0%,#c9ccd1 42%,#9fa3aa 58%,#eceef0 100%)'],
    [/(noir|black|onyx)/i, 'linear-gradient(135deg,#4a4a4a 0%,#141414 60%,#2b2b2b 100%)'],
    [/(blanc|white|nacre|perle|pearl|ivoire|ivory)/i, 'linear-gradient(135deg,#ffffff 0%,#f1ece4 55%,#e2dbd0 100%)'],
    [/(bronze|cuivre|copper)/i, 'linear-gradient(135deg,#e7b48a 0%,#b06d3f 55%,#8c512b 100%)'],
    [/(vert|green|[ée]meraude|emerald)/i, 'linear-gradient(135deg,#7fbf9a 0%,#2e7d57 100%)'],
    [/(bleu|blue|saphir|sapphire)/i, 'linear-gradient(135deg,#8fb3e8 0%,#2a4f96 100%)'],
    [/(rouge|red|rubis|ruby)/i, 'linear-gradient(135deg,#e88f8f 0%,#9e2a2a 100%)'],
    [/(rose|pink)/i, 'linear-gradient(135deg,#f7c9d4 0%,#e091a6 100%)']
  ];

  function swatchFor(value) {
    for (var i = 0; i < PALETTE.length; i++) {
      if (PALETTE[i][0].test(value)) return PALETTE[i][1];
    }
    return null;
  }

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  var memory = {};
  function getProduct(handle) {
    var key = 'leer:p:' + lang + ':' + handle;
    if (memory[key]) return memory[key];
    try {
      var cached = sessionStorage.getItem(key);
      if (cached) {
        var parsed = JSON.parse(cached);
        if (parsed && Date.now() - parsed.t < 10 * 60 * 1000) {
          memory[key] = Promise.resolve(parsed.p);
          return memory[key];
        }
      }
    } catch (e) {}
    memory[key] = fetch(root() + 'products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (p) {
          try { sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), p: slim(p) })); } catch (e) {}
        }
        return p ? slim(p) : null;
      })
      .catch(function () { return null; });
    return memory[key];
  }

  function slim(p) {
    return {
      available: p.available,
      price_varies: p.price_varies,
      options: (p.options || []).map(function (o) {
        return typeof o === 'string' ? { name: o, values: null } : { name: o.name, values: o.values };
      }),
      variants: (p.variants || []).map(function (v) {
        return {
          id: v.id,
          available: v.available,
          price: v.price,
          compare_at_price: v.compare_at_price,
          options: v.options,
          image: v.featured_image ? v.featured_image.src : (v.featured_media && v.featured_media.preview_image ? v.featured_media.preview_image.src : null)
        };
      }),
      media: (p.media || []).map(function (m) {
        return { alt: m.alt || '', src: m.preview_image ? m.preview_image.src : m.src };
      })
    };
  }

  function sized(src, w) {
    if (!src) return src;
    var s = src.indexOf('//') === 0 ? 'https:' + src : src;
    return s + (s.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function money(cents) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    try {
      return new Intl.NumberFormat(lang === 'en' ? 'en-GB' : 'fr-FR', { style: 'currency', currency: currency }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2) + ' ' + currency;
    }
  }

  function unique(list) {
    var out = [];
    list.forEach(function (x) { if (x != null && out.indexOf(x) === -1) out.push(x); });
    return out;
  }

  function stop(e) {
    e.preventDefault();
    e.stopPropagation();
  }

  function build(card, p, handle) {
    var idx = -1;
    p.options.forEach(function (o, i) {
      if (idx < 0 && COLOR_OPTION.test(String(o.name).trim())) idx = i;
    });
    if (idx < 0) return;

    var values = p.options[idx].values || unique(p.variants.map(function (v) { return v.options[idx]; }));
    if (!values || values.length < 2) return;
    if (!p.available && !cfg.showWhenSoldOut) return;

    var info = card.querySelector('.card > .card__content .card-information') || card.querySelector('.card-information');
    if (!info || card.querySelector('.leer-sw')) return;

    var colors = values.map(function (val) {
      var vs = p.variants.filter(function (v) { return v.options[idx] === val; });
      var pick = vs.filter(function (v) { return v.available; })[0] || vs[0];
      var img = null;
      for (var i = 0; i < vs.length && !img; i++) img = vs[i].image;
      if (!img) {
        var needle = String(val).toLowerCase();
        var m = p.media.filter(function (x) { return x.alt.toLowerCase().indexOf(needle) > -1; })[0];
        if (m) img = m.src;
      }
      return {
        value: val,
        variant: pick,
        available: vs.some(function (v) { return v.available; }),
        image: img,
        swatch: swatchFor(val)
      };
    });

    var firstAvailable = p.variants.filter(function (v) { return v.available; })[0] || p.variants[0];
    var current = 0;
    colors.forEach(function (c, i) { if (firstAvailable && c.value === firstAvailable.options[idx]) current = i; });

    var img = card.querySelector('.card__media .media img');
    var original = img ? { src: img.getAttribute('src'), srcset: img.getAttribute('srcset') } : null;
    var links = Array.prototype.slice.call(card.querySelectorAll('a[href*="/products/"]'));
    var baseHref = links.length ? links[0].getAttribute('href').split('?')[0] : null;
    var priceRegular = card.querySelector('.price__regular .price-item--regular');
    var priceSale = card.querySelector('.price__sale .price-item--sale');

    var wrap = document.createElement('div');
    wrap.className = 'leer-sw';
    var list = document.createElement('div');
    list.className = 'leer-sw__list';
    list.setAttribute('role', 'radiogroup');
    list.setAttribute('aria-label', p.options[idx].name || T.color);
    var label = document.createElement('span');
    label.className = 'leer-sw__label';
    var status = document.createElement('p');
    status.className = 'leer-sw__status';
    status.hidden = true;
    status.textContent = T.soldout;

    var dots = [];
    colors.forEach(function (c, i) {
      if (i >= MAX_DOTS) return;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'leer-sw__dot' + (c.available ? '' : ' is-soldout') + (c.swatch ? '' : ' is-text');
      b.setAttribute('role', 'radio');
      b.setAttribute('aria-label', c.value + (c.available ? '' : ' — ' + T.soldout));
      b.setAttribute('title', c.value);
      b.tabIndex = -1;
      if (c.swatch) {
        b.style.setProperty('--sw', c.swatch);
      } else {
        var initial = document.createElement('span');
        initial.className = 'leer-sw__initial';
        initial.textContent = String(c.value).charAt(0).toUpperCase();
        b.appendChild(initial);
      }
      b.addEventListener('click', function (e) {
        stop(e);
        select(i, true);
      });
      b.addEventListener('mouseenter', function () { preview(i); });
      b.addEventListener('focus', function () { preview(i); });
      list.appendChild(b);
      dots.push(b);
    });

    if (colors.length > MAX_DOTS && baseHref) {
      var more = document.createElement('a');
      more.className = 'leer-sw__more';
      more.href = baseHref;
      more.textContent = '+' + (colors.length - MAX_DOTS);
      more.setAttribute('aria-label', '+' + (colors.length - MAX_DOTS) + ' ' + T.more);
      list.appendChild(more);
    }

    list.addEventListener('mouseleave', function () { preview(current); });
    list.addEventListener('keydown', function (e) {
      var n = null;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') n = (current + 1) % dots.length;
      if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') n = (current - 1 + dots.length) % dots.length;
      if (n !== null) {
        e.preventDefault();
        select(n, true);
        dots[n].focus();
      }
    });

    wrap.appendChild(list);
    wrap.appendChild(label);

    /* Un clic ou un toucher dans la zone des pastilles ne doit jamais ouvrir la fiche produit */
    ['click', 'mousedown', 'touchstart', 'pointerdown'].forEach(function (type) {
      wrap.addEventListener(type, function (e) { e.stopPropagation(); });
    });
    wrap.addEventListener('click', function (e) { if (!e.target.closest('.leer-sw__more')) e.preventDefault(); });

    /* Les pastilles sont placées sur la carte elle-même (au-dessus du lien invisible qui couvre la carte), en haut à gauche de la photo */
    var priceEl = info.querySelector('.price');
    wrap.classList.add('leer-sw--overlay');
    card.appendChild(wrap);
    if (priceEl && priceEl.parentNode === info) { priceEl.insertAdjacentElement('afterend', status); } else { info.appendChild(status); }

    var shown = -1;
    function showImage(i) {
      if (!img || i === shown) return;
      shown = i;
      var c = colors[i];
      var next = c && c.image;
      if (!next) {
        if (original && img.getAttribute('src') !== original.src) swap(original.src, original.srcset);
        return;
      }
      var srcset = [360, 533, 720, 940, 1066].map(function (w) { return sized(next, w) + ' ' + w + 'w'; }).join(', ');
      swap(sized(next, 533), srcset);
    }

    function swap(src, srcset) {
      var pre = new Image();
      pre.onload = function () {
        img.classList.add('leer-sw-fade');
        setTimeout(function () {
          if (srcset) img.setAttribute('srcset', srcset); else img.removeAttribute('srcset');
          img.setAttribute('src', src);
          img.classList.remove('leer-sw-fade');
        }, 180);
      };
      pre.src = src;
    }

    function preview(i) {
      if (window.matchMedia('(hover: hover)').matches) showImage(i);
    }

    function select(i, userAction) {
      current = i;
      var c = colors[i];
      dots.forEach(function (d, k) {
        var on = k === i;
        d.classList.toggle('is-active', on);
        d.setAttribute('aria-checked', on ? 'true' : 'false');
        d.tabIndex = on ? 0 : -1;
      });
      label.textContent = c.value;
      status.hidden = c.available || !p.available;
      card.classList.toggle('leer-sw-soldout', !c.available);
      shown = -1;
      showImage(i);
      if (baseHref && c.variant) {
        links.forEach(function (a) { a.setAttribute('href', baseHref + '?variant=' + c.variant.id); });
      }
      if (userAction && p.price_varies && c.variant && priceRegular) {
        priceRegular.textContent = money(c.variant.price);
        if (priceSale) priceSale.textContent = money(c.variant.price);
      }
    }

    select(current, false);
    requestAnimationFrame(function () { wrap.classList.add('is-ready'); });
  }

  function handleOf(card) {
    var a = card.querySelector('a[href*="/products/"]');
    if (!a) return null;
    var m = a.getAttribute('href').match(/\/products\/([^\/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }

  function scan(scope) {
    var cards = (scope || document).querySelectorAll('.card-wrapper:not([data-leer-sw])');
    Array.prototype.forEach.call(cards, function (card) {
      card.setAttribute('data-leer-sw', '1');
      var handle = handleOf(card);
      if (!handle) return;
      getProduct(handle).then(function (p) { if (p) build(card, p, handle); });
    });
  }

  var queued = false;
  function queueScan() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; scan(); });
  }

  function init() {
    scan();
    if ('MutationObserver' in window) {
      new MutationObserver(function (records) {
        for (var i = 0; i < records.length; i++) {
          if (records[i].addedNodes.length) { queueScan(); break; }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
